module.exports = __webpack_public_path__ + "static/media/ella.5c73ff2b.jpg";